import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook, MessageCircle, Sparkles } from 'lucide-react';
import './Footer.css';

function Footer() {
  return (
    <footer className="shynea-footer">
      <div className="footer-glow" aria-hidden="true" />

      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <Sparkles size={18} className="footer-logo-icon" />
            <span>Shynea</span>
          </Link>
          <p className="footer-tagline">
            Votre plateforme beauté &amp; bien-être à Dakar.
            <br />
            Des salons soigneusement sélectionnés, réservation en 2 clics.
          </p>
          <div className="footer-social">
            <a href="https://instagram.com" aria-label="Instagram" className="social-btn">
              <Instagram size={16} />
            </a>
            <a href="https://facebook.com" aria-label="Facebook" className="social-btn">
              <Facebook size={16} />
            </a>
            <a href="https://wa.me/221771234567" aria-label="WhatsApp" className="social-btn">
              <MessageCircle size={16} />
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Explorer</h4>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/salons">Salons</Link></li>
            <li><Link to="/favoris">Mes favoris</Link></li>
            <li><Link to="/reservations">Mes réservations</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>À propos</h4>
          <ul>
            <li><a href="#about">Qui sommes-nous</a></li>
            <li><a href="#partners">Devenir partenaire</a></li>
            <li><a href="#press">Presse</a></li>
            <li><a href="#careers">Nous rejoindre</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul className="footer-contact">
            <li>
              <Mail size={14} />
              <a href="mailto:contact@shynea.one">contact@shynea.one</a>
            </li>
            <li>
              <Phone size={14} />
              <a href="tel:+221771234567">+221 77 123 45 67</a>
            </li>
            <li>
              <MapPin size={14} />
              <span>Dakar, Sénégal</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Shynea. Tous droits réservés.</p>
        <div className="footer-legal">
          <Link to="/cgu">Conditions</Link>
          <span className="dot">·</span>
          <Link to="/confidentialite">Confidentialité</Link>
          <span className="dot">·</span>
          <Link to="/mentions-legales">Mentions légales</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
